import React, { useContext, useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { DirectionContext } from '../Contexts/DirectionContext'
import { Link } from 'react-router-dom';
import WOW from 'wowjs';

// Values data object
const valuesData = [
  {
    id: 1,
    titleKey: "values.transparency.title",
    descriptionKey: "values.transparency.description",
    defaultTitle: "الشفافية",
    defaultDescription: "نقدم استشارات قانونية واضحة ومستندة إلى حقائق"
  },
  {
    id: 2,
    titleKey: "values.integrity.title",
    descriptionKey: "values.integrity.description",
    defaultTitle: "المصداقية",
    defaultDescription: "نضع مصلحة عملائنا أولاً ونلتزم بأعلى المعايير الأخلاقية"
  },
  {
    id: 3,
    titleKey: "values.excellence.title",
    descriptionKey: "values.excellence.description",
    defaultTitle: "التميز",
    defaultDescription: "نعمل بشغف وخبرة لتحقيق أفضل النتائج القانونية لعملائنا"
  },
  {
    id: 4,
    titleKey: "values.commitment.title",
    descriptionKey: "values.commitment.description",
    defaultTitle: "الالتزام",
    defaultDescription: "نتابع كل قضية بدقة حتى نحقق العدالة لعملائنا"
  }
];

// Reusable ValueCard component
const ValueCard = ({ titleKey, descriptionKey, defaultTitle, defaultDescription }) => (
  <div className="col-lg-6 col-xl-3 card-container">
    <div className="ValuesCard gap-2 p-3">
      <img
        src={require('../../Assets/images/logoName.png')}
        alt="logo light"
        className="bg-logo bg-logo-light"
      />
      <img
        src={require('../../Assets/images/logoName.png')}
        alt="logo dark"
        className="bg-logo bg-logo-dark"
      />
      <h2 className="ValuesCard-Title">
        <Trans i18nKey={titleKey}>{defaultTitle}</Trans>
      </h2>
      <h5 className="ValuesCard-text" >
        <Trans i18nKey={descriptionKey}>{defaultDescription}</Trans>
      </h5>
    </div>
  </div>
);

export default function AboutUs() {
  useEffect(() => {
    new WOW.WOW({
      live: true,
      mobile: false
    }).init();
  }, []);

  const { t, i18n } = useTranslation();
  const { dir } = useContext(DirectionContext);


  return (
    <div>
      <div className="container-fluid PagesLyout">
        {/* Hero Section (unchanged) */}
        <div className="WhoHero mx-lg-4 mb-5 p-2 py-3">
          <div className="Wholayer"></div>
          <div className="Hero-Content-container">
            <div className="row justify-content-center w-100 g-3">
              <div className="col-md-10 col-lg-11">
                <h1 className='WhoUSTitle'><Trans i18nKey="whoHero.title">نقدم ثروة من الخبرة في مختلف التخصصات القانونية </Trans></h1>
              </div>
              <div className="col-md-10 col-lg-9 col-xl-8 mb-lg-4">
                <h3><Trans i18nKey="whoHero.description"> نؤمن بأن العدالة تبدأ بالمعرفة والخبرة. فريقنا من المحامين المتمرسين مستعد لتقديم المشورة القانونية التي تحتاجها لحماية حقوقك واتخاذ القرارات الصحيحة.</Trans></h3>
              </div>
              <div className="col-md-12">
                <Link to="/info/contact">
                  <button className='HeroBtn py-3 px-3  py-md-3 px-md-4'>
                    <Trans i18nKey="BookBtn">احجز استشارتك القانونية الآن</Trans>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Vision Section (unchanged) */}
        <section>
          <div className="row mx-4">
            <div className="col-md-12 headlineContainer">
              <h2 className='Title  px-2 my-5 wow fadeInLeft' data-wow-delay="0.3s" >
                <div className='indicator'></div>
                <Trans i18nKey="vision.title">رؤيتنا</Trans>
              </h2>
            </div>
            <div className="col-md-12">
              <div className="row  align-items-end">
                <div className="col-md-11">
                  <h3 className='subtitle wow fadeIn px-2 justify-margin ' data-wow-delay="0.6s" dir={i18n.dir()} style={{ fontFamily: 'var(--font2)' }} >
                    <Trans
                      i18nKey="vision.description"
                      values={{ CompanyName: t('CompanyName') }}
                      components={{ span: <span style={{ fontWeight: "700" }} /> }}
                    />
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Values Section - Refactored with map() */}
        <section>
          <div className="row mx-4">
            <div className="col-md-12 headlineContainer">
              <h2 className='Title  px-2 my-5 wow fadeInLeft' data-wow-delay="0.3s" >
                <div className='indicator'></div>
                <Trans i18nKey="values.title">قيمنا</Trans>
              </h2>
            </div>
            <div className="col-md-12">
              <div className="row align-items-end px-2">
                <div className="col-md-12">
                  <div className="row g-3 g-xl-5 wow fadeIn" data-wow-delay="0.6s">
                    {valuesData.map((card) => (
                      <ValueCard
                        key={card.id}
                        titleKey={card.titleKey}
                        descriptionKey={card.descriptionKey}
                        defaultTitle={card.defaultTitle}
                        defaultDescription={card.defaultDescription}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className='pt-5 m-0'>
        <div className="AboutUS-Hero-container  px-3">
          <div className="row justify-content-center text-center align-items-baseline mt-5">
            <div className="col-md-10 col-lg-8 p-4 Services-Booking-card wow fadeIn" data-wow-delay="0.7s">
            <div className="row justify-content-center gap-3">
              <div className="col-md-12">
                <h2 className='Title  wow fadeInRight justify-content-center' data-wow-delay="0.3s">
                <Trans i18nKey="Aboutus.consultTitle">
                  احجز استشارتك القانونية الآن
                </Trans>
              </h2>
              </div>
              <div className="col-md-10">
                <h3 className='mb-3' style={{ fontFamily: 'Saudi' }}>
                <Trans i18nKey="Aboutus.consultText">
                  نضمن راحتكم يمكنكم الحصول على استشارتكم القانوينة عن بعد أو شرفونا بحضوركم للمكتب-نأنس بكم.
                </Trans>
              </h3>
              </div>
              <div className="col-md-12">
                 <h3 className='WorkingTime'>
                <Trans i18nKey="Aboutus.WorkingTime">
                مواعيد العمل
                </Trans>
              </h3>
              <h5 className='subtitle'>
                <Trans i18nKey="Aboutus.WorkingDays">
                    الأحد - الخميس
                </Trans>
              </h5>
              <h5 className='subtitle'>
                 <Trans i18nKey="Aboutus.WorkingHours">
                   9:00 صباحًا - 6:00 مساءً
                </Trans>
              </h5>
              </div>
              <div className="col-md-12 mt-3">
                   <Link to="/info/contact">
                <button className='HeroBtn p-3 px-4 wow fadeInLeft' data-wow-delay="0.6s">
                  <Trans i18nKey="Aboutus.consultButton">
                    احجز استشارتك عن بعد
                  </Trans>
                </button>
              </Link>
              </div>
            </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}